export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#02A5AD',
    },
    secondary: {
      main: '#BF087E',
      light: '#fa80cf',
      extraLight: '#fdc9eb',
      dark: '#850558',
    },
    tertiary: {
      main: '#FDC50D',
      dark: '#b68c02',
      light: '#fee595',
      extraLight: '#fff9e6',
      contrastText: '#fff',
    },
    error: {
      main: '#fb2111',
    },
    black: {
      main: '#000000',
    },
  },
  typography: {
    button: {
      fontSize: '1.1rem',
    },
    fontFamily: '"Didact Gothic", "sans-serif"',
    fontSize: 16,
    subtitle2: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '1rem',
    },
  },
  shape: {
    borderRadius: 30,
  },
  spacing: 15,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 850,
      lg: 1200,
      xl: 1600,
      xxl: 2000,
    },
  },
};
